// Copyright (c) 2026, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.
import React from "react";
import { makeStyles } from "tss-react/mui";
import { AppConfig } from "@configs/admin-config";
import useHttp from "@utils/http";
import { useEffect } from "react";
import { useState } from "react";
import { LinearProgress } from "@mui/material";
import { Backdrop, CircularProgress } from "@mui/material";

const useStyles = makeStyles()((theme) => ({
  imageDiv: {
    textAlign: "center",
    height: "10%",
    marginTop: 48,
  },
  image: {
    textAlign: "center",
    maxWidth: "100%",
    height: "auto",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
}));

const ViewImage = (props) => {
  const { classes } = useStyles();
  const [backdropOpen, setbackDrop] = useState(false);
  const [url, setUrl] = useState(null);
  const { isLoading, data, error, sendRequestForImage, reqExtra, isOpen } = useHttp();

  const getQueryParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return {
      fileName: urlParams.get('fileName'),
      extension: urlParams.get('extension')
    };
  };

  const { fileName, extension } = getQueryParams();

  const getImage = (fileName, fileExtension) => {
    setbackDrop(true);
    if (fileName && fileExtension) {
      sendRequestForImage(
        AppConfig.baseUrl + AppConfig.files + "/" + fileName + "?fileExtension=" + fileExtension,
        "GET",
        null,
        AppConfig.files
      );
    } else {
      setbackDrop(false);
    }
  };

  useEffect(() => {
    switch (reqExtra) {
      case AppConfig.files:
        if (data) {
          setbackDrop(false);
          setUrl(data);
        }
        break;
      default:
        break;
    }
  }, [data, reqExtra, isOpen, isLoading, error]);

  useEffect(() => {
    getImage(fileName, extension);
  }, [fileName, extension]);

  return (
    <React.Fragment>
      <Backdrop open={backdropOpen} className={classes.backdrop}>
        <CircularProgress color="secondary" />
      </Backdrop>
      {isLoading ? (
        <LinearProgress />
      ) : (
        fileName && extension && (
          <div className={classes.imageDiv}>
            {url ? <img className={classes.image} src={url} alt={fileName} /> : "No image"}
          </div>
        )
      )}
    </React.Fragment>
  );
};

export default ViewImage;
